import React from 'react';
import Heading from '../../Components/Heading';
import Map from '../../Components/Map';
import Markers from '../../Components/Map/Markers';

const MapArea = () => {
  return (
    <div className="contact-map-container">
      <div className="contact-map-heading">
        <Heading title="FIND US ON GOOGLE MAPS" />
      </div>
      <div className="contact-map-content">
        <Map
          className="contact-map"
          defaultZoom={16}
          defaultCenter={{ lat: 22.589726, lng: 88.4045107 }}>
          <Markers data={[{ lat: 22.589726, lng: 88.4045107 }]} />
        </Map>
      </div>
    </div>
  );
};

export default MapArea;



// WEBPACK FOOTER //
// ./src/Pages/Contact/MapArea.js